/**
 * Resolves the client domain from URL query params, environment variable, or hostname.
 * @returns {string}
 */
export const getClientDomain = () => {
    if (typeof window === 'undefined') return '';
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('domain') || process.env.REACT_APP_CLIENT_DOMAIN || window.location.hostname;
};
